import { i18nKeyPrefix } from 'main/components/school/i18n'
import { TFunction } from 'react-i18next'

const PRE = `${i18nKeyPrefix}-PROGRAM-TYPE`

export function labelForProgramType(programType: string, t: TFunction): string | null {
  switch (programType) {
    case 'fcc':
      return t(`${PRE}-FCC`)
    case 'ministry':
      return t(`${PRE}-MINISTRY`)
    case 'forest':
      return t(`${PRE}-FOREST`)
    case 'micro':
      return t(`${PRE}-MICRO`)
    case 'center':
      return t(`${PRE}-CENTER`)
    case 'nanny':
      return t(`${PRE}-NANNY`)
    case 'other':
      return t(`${PRE}-OTHER`)
    case 'exempt':
      return t(`${PRE}-EXEMPT`)
    default:
      return null
  }
}
